export const ProgressMixin = {
  methods: {
    async addProgressIfNotExist(message, progressKey = 'progress') {
      if (!this[progressKey]) {
        this[progressKey] = await this.addProgress(this.$i18n.t(message));
      }
    },
    async handleProgressNotification(data, successMessage, errorDialogTitle, defaultErrorMessage, progressKey = 'progress') {
      await this.addProgressIfNotExist(null, progressKey);
      this.updateProgressValue({
        progressValue: parseInt(Math.round(data.successful / data.total * 100)),
        uuid: this[progressKey].uuid
      });
      
      if (data.is_finished) {
        if (!data.errors) {
          this.$toast('success', this.$i18n.t(successMessage));
        }
        this.removeProgressIfExist(progressKey);
        this.getTableData();
      }
      if (data.errors) {
        if (data.errors.non_field_errors) {
          this.$errorDialog(data.errors.non_field_errors[0])
        } else if (data.errors.errors) {
          const listItemsArr = [];
          data.errors.errors.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
          this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t(errorDialogTitle));
        } else if (data.errors.mapped_errors) {
          const listItemsArr = [];
          for (let i in data.errors.mapped_errors) {
            for (let j in data.errors.mapped_errors[i]) {
              listItemsArr.push(this.$createElement('li', {}, data.errors.mapped_errors[i][j][0]))
            }
          }
          this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t(errorDialogTitle));
        } else {
          this.$errorDialog(this.$i18n.t(defaultErrorMessage))
        }
      }
    },
    removeProgressIfExist(progressKey = 'progress') {
      if (this[progressKey]) {
        this.removeProgress(this[progressKey].uuid);
        this[progressKey] = null;
      }
    },
  }
}

